import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { FaBuilding } from "react-icons/fa";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "./Projects.css";
import { Helmet } from "react-helmet-async";

// -------------------- GOVERNMENT PROJECTS --------------------
const governmentProjects = [
  { id: 1, image: require("../assets/projects/GOV1.jpg"), title: "Gov Project 1", desc: "Government Building ACP Facade" },
  { id: 2, image: require("../assets/projects/GOV 2.jpg"), title: "Gov Project 2", desc: "Airport Lounge Panels" },
  { id: 3, image: require("../assets/projects/GOV  3.jpg"), title: "Gov Project 3", desc: "Transport Terminal Design" },
  { id: 4, image: require("../assets/projects/GOV  4.jpg"), title: "Gov Project 4", desc: "Gov HQ Front Elevation" },
  { id: 5, image: require("../assets/projects/GOV  5.jpg"), title: "Gov Project 5", desc: "Stadium ACP Work" },
  { id: 6, image: require("../assets/projects/GOV  6.jpg"), title: "Gov Project 6", desc: "Gov Complex Facade" },
  { id: 7, image: require("../assets/projects/GOV  7.jpg"), title: "Gov Project 7", desc: "Utility Service Campus" },
];

// -------------------- PRIVATE PROJECTS (IDs removed) --------------------
const privateProjects = [
  // CHHATTISGARH
  { image: require("../assets/zone-projects/Chhattisgarh/5e6cd74c-a295-4cd3-bdb9-aacf1ed2bd67.jpg"), title: "Private Project 1", desc: "Retail Showroom Panels", state: "CHHATTISGARH" },
  { image: require("../assets/zone-projects/Chhattisgarh/bisalpur new.jpg"), title: "Private Project 2", desc: "Luxury Mall Interior", state: "CHHATTISGARH" },
  { image: require("../assets/zone-projects/Chhattisgarh/bisalpur.jpg"), title: "Private Project 3", desc: "Commercial Office Tower", state: "CHHATTISGARH" },

  // GUJRAT
  { image: require("../assets/zone-projects/gujrat/surat.jpg"), title: "Private Project 4", desc: "Film City Entrance Panels", state: "GUJRAT" },
  { image: require("../assets/zone-projects/gujrat/surat.jpg"), title: "Private Project 5", desc: "Modern Hospital Elevation", state: "GUJRAT" },
  { image: require("../assets/zone-projects/gujrat/surat.jpg"), title: "Private Project 6", desc: "Corporate Park Elevation", state: "GUJRAT" },

  // HARYANA
  { image: require("../assets/zone-projects/Haryana/Faridabad neww.jpg"), title: "Private Project 7", desc: "Shopping Complex Panels", state: "HARYANA" },
  { image: require("../assets/zone-projects/Haryana/Faridabad.jpg"), title: "Private Project 8", desc: "Luxury Office Interior", state: "HARYANA" },
  { image: require("../assets/zone-projects/Haryana/Faridabad neww.jpg"), title: "Private Project 9", desc: "Hospital Front Facade", state: "HARYANA" },

    { image: require("../assets/zone-projects/Haryana/sep-IMG-20250911-WA0001.jpg"), title: "Private Project 7", desc: "Shopping Complex Panels", state: "HARYANA" },
  { image: require("../assets/zone-projects/Haryana/sep-IMG-20250911-WA0002.jpg"), title: "Private Project 8", desc: "Luxury Office Interior", state: "HARYANA" },
  { image: require("../assets/zone-projects/Haryana/sep-IMG-20250911-WA0003.jpg"), title: "Private Project 9", desc: "Hospital Front Facade", state: "HARYANA" },

  // MP
  { image: require("../assets/zone-projects/Mp/Indore2.jpg"), title: "Private Project 10", desc: "Cinema Hall Exterior", state: "MP" },
  { image: require("../assets/zone-projects/Mp/Indore4.jpg"), title: "Private Project 11", desc: "Business Tower Panels", state: "MP" },
  { image: require("../assets/zone-projects/Mp/Sehore.jpg"), title: "Private Project 12", desc: "School Elevation Work", state: "MP" },
  { image: require("../assets/zone-projects/Mp/Ujjain new.jpg"), title: "Private Project 13", desc: "School Elevation Work", state: "MP" },
  { image: require("../assets/zone-projects/Mp/Ujjain.jpg"), title: "Private Project 14", desc: "School Elevation Work", state: "MP" },
  { image: require("../assets/zone-projects/Mp/indore 3.jpg"), title: "Private Project 15", desc: "School Elevation Work", state: "MP" },
  { image: require("../assets/zone-projects/Mp/indore.jpg"), title: "Private Project 16", desc: "School Elevation Work", state: "MP" },
  { image: require("../assets/zone-projects/Mp/jabalpur.jpg"), title: "Private Project 17", desc: "School Elevation Work", state: "MP" },
  { image: require("../assets/zone-projects/Mp/sep-Rewa, MP.jpg"), title: "Private Project 17", desc: "School Elevation Work", state: "MP" },

  // UP
  { image: require("../assets/zone-projects/UP/Agra.jpg"), title: "Private Project 18", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/Azamgarh.jpg"), title: "Private Project 19", desc: "IT Park ACP Work", state: "UP" },
  { image: require("../assets/zone-projects/UP/Chakia.jpg"), title: "Private Project 20", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/Hapur new.jpg"), title: "Private Project 21", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/Hapur.jpg"), title: "Private Project 22", desc: "IT Park ACP Work", state: "UP" },
  { image: require("../assets/zone-projects/UP/Kharihani.jpg"), title: "Private Project 23", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/Lucknow.jpg"), title: "Private Project 24", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/Mau.jpg"), title: "Private Project 25", desc: "IT Park ACP Work", state: "UP" },
  { image: require("../assets/zone-projects/UP/Varanasi.jpg"), title: "Private Project 26", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/Varanasinew.jpg"), title: "Private Project 27", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/bisalpur.jpg"), title: "Private Project 28", desc: "IT Park ACP Work", state: "UP" },
  { image: require("../assets/zone-projects/UP/kaushambi.jpg"), title: "Private Project 29", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/meerut.jpg"), title: "Private Project 30", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/modipuram, meerut.jpg"), title: "Private Project 31", desc: "IT Park ACP Work", state: "UP" },

    { image: require("../assets/zone-projects/UP/sep-merut.jpg"), title: "Private Project 24", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Sri Ganga nagar, rajashthan.jpg"), title: "Private Project 25", desc: "IT Park ACP Work", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Meerut.jpg"), title: "Private Project 26", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Meerut 33.jpg"), title: "Private Project 27", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Manyavar showroom in Agra.jpg"), title: "Private Project 28", desc: "IT Park ACP Work", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Lucknow2.jpg"), title: "Private Project 29", desc: "Hotel Facade Design", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Lucknow.jpg"), title: "Private Project 30", desc: "Retail Mall Entrance", state: "UP" },
  { image: require("../assets/zone-projects/UP/sep-Azamgarh.jpg"), title: "Private Project 31", desc: "IT Park ACP Work", state: "UP" },
   { image: require("../assets/zone-projects/UP/sep-Azamgarh, UP.jpg"), title: "Private Project 31", desc: "IT Park ACP Work", state: "UP" },
    { image: require("../assets/zone-projects/UP/sep-Allahabad.jpg"), title: "Private Project 31", desc: "IT Park ACP Work", state: "UP" },

  // WEST BANGOLE
  { image: require("../assets/zone-projects/wb/Asansol.jpg"), title: "Private Project 32", desc: "Metro Station Panels", state: "WEST BANGOLE" },
  { image: require("../assets/zone-projects/wb/Raniganj.jpg"), title: "Private Project 33", desc: "Convention Center Interior", state: "WEST BANGOLE" },
  { image: require("../assets/zone-projects/wb/Asansol.jpg"), title: "Private Project 34", desc: "Luxury Resort Exterior", state: "WEST BANGOLE" },

    // J&K  ✅  (NEW)
  { image: require("../assets/zone-projects/J&k/jk1.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk2.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
    { image: require("../assets/zone-projects/J&k/jk3.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  // { image: require("../assets/zone-projects/J&k/jk4.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
    { image: require("../assets/zone-projects/J&k/jk5.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk6.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },  { image: require("../assets/zone-projects/J&k/jk1.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk7.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
    { image: require("../assets/zone-projects/J&k/jk8.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk9.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
    { image: require("../assets/zone-projects/J&k/jk10.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk11.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
    { image: require("../assets/zone-projects/J&k/jk12.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk2.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
    { image: require("../assets/zone-projects/J&k/jk13.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
  { image: require("../assets/zone-projects/J&k/jk14.jpg"), title: "Private Project 1", desc: "Hotel Facade Design", state: "J&K" },
];

// -------------------- CLIENTS --------------------
const allClients = [
  "Kalyan Jewellers – UAE", "Kalyan Jewellers – PAN INDIA", "Sardar Vallabh Bhai Patel Airport, Ahmedabad",
  "Ramoji Film City, Hydrabad", "Transport Corporation, Bangalore", "ITC Outlets", "Coffee Day Lounge", "ONGC",
  "Chennai Airport", "Godrej Building, Kathmadnu", "Maharajganj, Kathmandu", "Baneshwor, Kathmadnu",
  "Kalimati, Kathmandu", "Koteshwar, Kathmandu", "Eissan Hospital, Kathmandu", "Prime Hi-Tech Infrastructure, Andra Pradesh",
  "Comio Mobiles", "Apollo Hospital", "BKC Complex, Mumbai", "Techniplex, Mumbai", "Solitaire Mall, Mumbai",
  "Town Centre, Mumbai", "Parker Mall, New Delhi", "Sports Stadium, Goa", "Radisson, Haridwar", "ONGC,VIZAG",
  "Reliance Milk, Vellore, Tamil Nadu", "McDonalds", "Calicut Bus Terminal Project", "Shri moga Hospital, Shimoga",
  "Nepal Telecom", "Ishaan Hospital, Maharajganj", "Volks Wagon", "Hatti Kaapi Chain", "Gujarat Gas"
];

const governmentClients = allClients.filter(name =>
  ["ONGC", "ONGC,VIZAG", "Nepal Telecom", "Transport Corporation, Bangalore",
   "Sardar Vallabh Bhai Patel Airport, Ahmedabad", "Chennai Airport",
   "Sports Stadium, Goa", "Calicut Bus Terminal Project", "Gujarat Gas"].includes(name)
);
const privateClients = allClients.filter(name => !governmentClients.includes(name));

const ProjectCarousel = () => {
  const [visibleClients, setVisibleClients] = useState(12);
  const [selectedState, setSelectedState] = useState("UP");

  // Filter + assign fresh IDs starting at 1
  const filteredProjects = privateProjects
    .filter(item => item.state === selectedState)
    .map((item, index) => ({ ...item, id: index + 1 }));

  const isFullyVisible = visibleClients >= privateClients.length;
  const handleToggleClients = () => {
    setVisibleClients(prev => (isFullyVisible ? 12 : prev + 12));
  };

  return (
    <>
    <Helmet>

  <title>Top ACP Company in India | Alutuff Projects</title>
  <meta name="description" content="Explore Alutuff’s premium projects — showcasing why we are a *top ACP company in India* and *best ACP supplier in Bareilly*. See real installations of the best ACP sheets." />
  <meta name="keywords" content="Best ACP Sheet Manufacturer in India, ACP sheet manufacturers in India, Best ACP Supplier in India, Top ACP Company in India, Best ACP Supplier in Bareilly, Best ACP Sheet in Bareilly" />
  <link rel="canonical" href="https://alutuff.in/projects" />

    </Helmet>

      <Container fluid className="projects-banner-section">
        <Container className="projects-banner-content-div">
          <div className="project-banner-text-div">
            <h1 className="project-banner-heading">
              Transforming Spaces with Durable, Stylish Panel Solutions
            </h1>
            <p className="project-banner-descp">
              At Alutuff, our panels are trusted by architects, builders, and developers across industries. Explore our diverse project portfolio to see how Alutuff enhances structures with quality craftsmanship and long-lasting protection.
            </p>
          </div>
          <div className="image-layout-wrapper">
            <div className="top-section">
              <div className="left-images">
                <img src={require("../assets/P 2.jpg")} alt="Image 1" className="img img1 from-left" />
                <img src={require("../assets/P3.jpg")} alt="Image 2" className="img img2 from-left" />
              </div>
              <img src={require("../assets/p1.jpg")} alt="Image 3" className="img img3 from-right" />
            </div>
          </div>
        </Container>
      </Container>

      {/* PRIVATE PROJECTS */}
      <Container className="project-carousel-container">
        <div className="d-flex flex-column align-items-center mb-4">
          <p className="page-heading">PRIVATE PROJECTS</p>
          <div className="d-flex flex-wrap justify-content-center gap-2 mb-4">
            {["CHHATTISGARH", "GUJRAT", "HARYANA", "MP", "UP", "WEST BANGOLE","J&K"].map(state => (
              <button
                key={state}
                className={`filter-btn pink-button ${selectedState === state ? "active" : ""}`}
                onClick={() => setSelectedState(state)}
              >
                {state}
              </button>
            ))}
          </div>
        </div>

        <Swiper
          modules={[Autoplay]}
          loop
          loopedSlides={filteredProjects.length}
          autoplay={{ delay: 1500 }}
          centeredSlides
          className="project-swiper"
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
          {(filteredProjects.length <= 3
            ? [...filteredProjects, ...filteredProjects]
            : filteredProjects
          ).map(item => (
            <SwiperSlide key={item.id} className="project-card custom-slide">
              <div className="project-inner">
                <img src={item.image} alt={item.title} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

      {/* PRIVATE CLIENTS */}
      <Container className="clients-section">
        <h2 className="page-heading">Private Clients</h2>
        <div className="clients-grid">
          {privateClients.slice(0, visibleClients).map((client, index) => (
            <div className="client-box" key={index}>
              <FaBuilding className="client-icon" />
              <span>{client}</span>
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-end mt-4">
          <button className="view-more-btn pink-button" onClick={handleToggleClients}>
            {isFullyVisible ? "View Less" : "View More"}
          </button>
        </div>
      </Container>

      {/* GOVERNMENT PROJECTS */}
      <Container className="project-carousel-container">
        <div className="d-flex justify-content-center align-items-center mb-5">
          <p className="page-heading">GOVERNMENT PROJECTS</p>
        </div>
        <Swiper
          modules={[Autoplay]}
          loop
          autoplay={{ delay: 2500 }}
          className="project-swiper"
          breakpoints={{
            0: { slidesPerView: 1, centeredSlides: false },
            768: { slidesPerView: 2, centeredSlides: true },
            992: { slidesPerView: 3, centeredSlides: true },
          }}
        >
          {governmentProjects.map(item => (
            <SwiperSlide key={item.id} className="project-card">
              <div className="project-inner">
                <img src={item.image} alt={item.title} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>

      {/* GOVERNMENT CLIENTS */}
      <Container className="clients-section">
        <h2 className="page-heading">Government Clients</h2>
        <div className="clients-grid">
          {governmentClients.map((client, index) => (
            <div className="client-box" key={index}>
              <FaBuilding className="client-icon" />
              <span>{client}</span>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default ProjectCarousel;
